import * as React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import styles from '../../styles/collectie.module.scss';
import { FontIcon, Image, Popup, Stack, mergeStyleSets } from "@fluentui/react";
import ImageViewerSplashContext from "../../_contexts/ImageViewerContext";
import GlobalContext from "../../_contexts/GlobalContext";

export interface IImageViewerSplashProps {
    // eslint-disable-next-line
}

export const popupStyles = mergeStyleSets({
    root: {
        background: 'rgba(0, 0, 0, 0.5)',
        bottom: '0',
        left: '0',
        position: 'fixed',
        right: '0',
        top: '0',
        zIndex: 999
    },
    content: {
        backgroundColor: "transparent",
        left: '50%',
        padding: '0 2em 2em',
        position: 'absolute',
        maxWidth: "90%!important",
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
});

const ImageViewerSplash: React.FunctionComponent<IImageViewerSplashProps> = (props: IImageViewerSplashProps) => {
    const [selectedImageIndex, setselectedImageIndex] = useState<number>(0);

    const { imgUrls, setImgUrls } = useContext(ImageViewerSplashContext);
    const { windowSize } = useContext(GlobalContext);

    const ImgRef = useRef<HTMLImageElement>(null);
    const DivRef = useRef<HTMLDivElement>(null);
    const zoom = 3;

    useEffect(() => {
        if (imgUrls && imgUrls.length > 0 && window.innerWidth >= 960) {
            setTimeout(() => { //TODO: fix this shit when your less tired
                AddMagnifier();
            },500);
        }
    },[imgUrls, selectedImageIndex]);

    function AddMagnifier() {
        let w, h, bw;
        let img = ImgRef.current;
        let glass = DivRef.current;
        glass.setAttribute("class", styles.ggggg);
        /*insert magnifier glass:*/
        img.parentElement.insertBefore(glass, img);
        /*set background properties for the magnifier glass:*/
        glass.style.backgroundImage = "url('" + img.src + "')";
        glass.style.backgroundRepeat = "no-repeat";
        glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
        bw = 3;
        w = glass.offsetWidth / 2;
        h = glass.offsetHeight / 2;
        /*execute a function when someone moves the magnifier glass over the image:*/
        glass.addEventListener("mousemove", moveMagnifier);
        img.addEventListener("mousemove", moveMagnifier);
        /*and also for touch screens:*/
        glass.addEventListener("touchmove", moveMagnifier);
        img.addEventListener("touchmove", moveMagnifier);

        glass.addEventListener("click", () => {setImgUrls([]); });

        function moveMagnifier(e) {
            var pos, x, y;
            /*prevent any other actions that may occur when moving over the image*/
            e.preventDefault();
            /*get the cursor's x and y positions:*/
            pos = getCursorPos(e);
            x = pos.x;
            y = pos.y;
            /*prevent the magnifier glass from being positioned outside the image:*/
            if (x > img.width - (w / zoom)) { x = img.width - (w / zoom); }
            if (x < w / zoom) { x = w / zoom; }
            if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
            if (y < h / zoom) { y = h / zoom; }
            /*set the position of the magnifier glass:*/
            glass.style.left = (x - w) + "px";
            glass.style.top = (y - h) + "px";
            /*display what the magnifier glass "sees":*/
            glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        }
        function getCursorPos(e) {
            var a, x = 0, y = 0;
            e = e || window.event;
            /*get the x and y positions of the image:*/
            a = img.getBoundingClientRect();
            /*calculate the cursor's x and y coordinates, relative to the image:*/
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /*consider any page scrolling:*/
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    };

    return (
        <Popup
            hidden={imgUrls.length === 0}
            role="dialog"
            aria-modal="true"
            className={popupStyles.root}
        >
            <div ref={DivRef}></div>   
            <div role="document" className={`${popupStyles.content} ${styles.imgmagnifiercontainer}`}>
                <Image className={`${styles.ccccc}`}
                    ref={ImgRef}
                    style={{ cursor: "none", maxHeight: windowSize.y - ((windowSize.y / 100) * 25), height: windowSize.y - ((windowSize.y / 100) * 25) }}
                    onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = `${imgUrls[selectedImageIndex]}`
                    }}
                    onClick={() => { setImgUrls([]) }}
                    src={imgUrls[selectedImageIndex]}
                    alt="" />
                <Stack horizontal horizontalAlign="center" style={{paddingTop:50}}>
                    {imgUrls.length > 0 && <FontIcon aria-label="Volgende" className={styles.prevNextIconLarge} onClick={() => {selectedImageIndex > 0 ? setselectedImageIndex(selectedImageIndex-1) : setselectedImageIndex(imgUrls.length -1)}} iconName="ChevronLeft" />}
                    {imgUrls.length > 0 && <FontIcon aria-label="Volgende" className={styles.prevNextIconLarge} onClick={() => {selectedImageIndex+1 < imgUrls.length ? setselectedImageIndex(selectedImageIndex+1) : setselectedImageIndex(0)}} iconName="ChevronRight" />}
                    <FontIcon aria-label="Volgende" className={styles.prevNextIconLarge} onClick={() => { setImgUrls([]); }} iconName="Cancel" />
                </Stack>
            </div>
            
        </Popup>
    );
}

export default ImageViewerSplash;